<template>
  <v-toolbar
    app
    clipped-left
    flat
    color="headerColor"
  >

    <slot name="navToggle"></slot>

    <!--must be implemented with changes to app.vue. this uses vuetify themes instead of the scss pages.-->
    <v-layout
      justify-center
      row
    >
      <!-- the following line will make the toolbar shorter or longer-->
      <v-flex :class="sizingClass">
        <div>
          <v-layout
            align-center
            flat
          >
            <v-toolbar-title style="color:#4485ed; font-weight:700; margin-left:0px; padding-top:5px; cursor:pointer">
              <img
                :src="logoSource"
                height="40"
                alt=""
              >
            </v-toolbar-title>
            <v-spacer></v-spacer>
            <v-menu
              bottom
              offset-y
            >
              <v-btn
                v-if="!isMobile"
                slot="activator"
                color="contrast"
                flat
              ><span style="text-transform: lowercase">{{theDisplayedAccount}}</span>
                <v-icon
                  small
                  class="ml-2"
                >person</v-icon>
              </v-btn>
              <v-btn
                v-else
                slot="activator"
                icon
                color="contrast"
                outline
              >
                <v-icon>person</v-icon>
              </v-btn>

              <v-list>
                <v-list-tile
                  v-for="(item, index) in menuItems"
                  :key="index"
                  @click="handleMenuSelection(index)"
                >
                  <v-list-tile-avatar>
                    <v-icon>{{item.icon}}</v-icon>
                  </v-list-tile-avatar>
                  <v-list-tile-title>{{ item.title }}</v-list-tile-title>
                </v-list-tile>
              </v-list>
            </v-menu>

          </v-layout>
        </div>
      </v-flex>
    </v-layout>
    <edit-patient-info-dialog ref="editPatientInfoDialog"></edit-patient-info-dialog>

    <v-divider style="position:absolute; bottom:0px; width:110%; left:0px;"></v-divider>
    <!-- the following line is to match the current smart choice tool bar functionality-->

  </v-toolbar>
</template>

<style lang="scss" scoped>
</style>


<script>
import DesktopHeader from '@/core/components/DesktopHeader'
import DesktopHeaderLinks from '@/components/headers/DesktopHeaderLinks'
import EditPatientInfoDialog from '@/components/dialogs/EditPatientInfoDialog'

import { mapState, mapActions } from 'vuex'

export default {
  name: 'OneHeader',
  components: {
    DesktopHeader,
    DesktopHeaderLinks,
    EditPatientInfoDialog
  },
  props: {
    provider: {
      type: Object
    },
    fullWidth: {
      type: Boolean,
      default: false
    }
  },
  data() {
    return {
      menuItems: [{ title: 'Logout', icon: 'exit_to_app', method: 'logout' }]
    }
  },
  methods: {
    ...mapActions('auth', ['signOut']),
    handleMenuSelection(index) {
      let method = this.menuItems[index].method

      if (method === 'logout') {
        this.logout()
      }
    },
    logout() {
      this.signOut()
      this.$router.push('/login')
    },
    toast(text, type) {
      this.showSnackbar = true
      this.snackbarType = type
      this.snackbarText = text
    },
    navPatients() {
      this.$router.push({
        name: 'PatientsPage'
      })
    },
    navAccount() {
      this.$router.push('/account')
    }
  },
  computed: {
    ...mapState('patient', ['patient']),
    ...mapState('provider', ['partner']),
    ...mapState('auth', ['user']),
    isMobile() {
      return this.$vuetify.breakpoint.smAndDown
    },
    sizingClass() {
      if (this.fullWidth) {
        return 'xs12'
      } else {
        return 'xs12 sm8'
      }
    },
    logoSource() {
      return 'https://storage.googleapis.com/onechart-assets/logos/login/default_normalized.png'
    },
    theDisplayedAccount() {
      if (this.user) {
        if (this.user.email) {
          return this.user.email
        } else if (this.user.firstName) {
          return this.user.firstName + ' ' + this.user.lastName
        } else {
          return 'Account'
        }
      } else {
        return 'Account'
      }
    }
  }
}
</script>



// WEBPACK FOOTER //
// src/components/headers/ApplicationHeader.vue